import { colorsTuple, createTheme } from '@mantine/core';

export const colors = createTheme({
  colors: {
    brand: [
      '#FDECEC',
      '#FCE3E3',
      '#F9C5C5',
      '#F38C8C',
      '#FF6552', // NEW BRAND COLOR (LUCKY BREAK)
      '#D43C3D',
      '#BC3636',
      '#B03233',
      '#8D2829',
      '#521718',
    ],
    red: [
      '#fae9e7',
      '#f8dedb',
      '#f0bbb5',
      '#E1776B',
      '#cd230f',
      '#b9200e',
      '#a41c0c',
      '#9a1a0b',
      '#7b1509',
      '#480c05',
    ],
    green: [
      '#e6f4ed',
      '#daefe5',
      '#b2dec8',
      '#5EBA8D',
      '#08934f',
      '#078447',
      '#06763f',
      '#066e3b',
      '#05582f',
      '#03331c',
    ],
    yellow: [
      '#fff9ec',
      '#fff6e3',
      '#ffebc4',
      '#FFDB94',
      '#ffc042',
      '#e6ad3b',
      '#cc9a35',
      '#bf9032',
      '#997328',
      '#594317',
    ],
    blue: [
      '#ecf1fb',
      '#e2eaf9',
      '#c3d5f4',
      '#7FA4E6',
      '#3e76da',
      '#386ac4',
      '#325eae',
      '#2f59a4',
      '#254783',
      '#16294c',
    ],
    gray: [
      '#F3F3F3',
      '#E7E6E6',
      '#D0CECE',
      '#B8B5B5',
      '#A09C9C',
      '#888383',
      '#716B6B',
      '#595252',
      '#413939',
      '#3A2D2D',
      '#F8F8F8',
    ],
    background: [
      '#F4F4F4',
      '#4D4D4D',
      '#F8F8F8',
      '#2E2E2E',
      '#F4F4F4',
      '#FAE9E7',
      '#FAE9E7',
      '#F8F8F8',
      '#FAE9E7',
      '#FAE9E7',
    ],
    'border-secondary': colorsTuple('#DBDDE4'),
    'content-primary': colorsTuple('#120808'),
    // Rebrand: override Mantine's `dark` palette so any `<Button color="dark">`
    // (the rebrand default in components.ts) renders in Brand/Primary/
    // "Ten Thousand Coffees" (#1F1511) rather than Mantine's near-black.
    dark: colorsTuple('#1F1511'),
  },
});
